import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { Contact } from '@/types'

export function useContacts() {
  return useQuery<(Contact & { key: string })[]>({
    queryKey: ['contacts'],
    queryFn: () => api.get('/contacts'),
  })
}

export function useCleanupContacts() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (type: 'all' | 'imported') =>
      api.delete<{ ok: boolean; removed: number }>('/contacts/cleanup', { type }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['contacts'] }),
  })
}
